import React from "react";

import { FaInstagram, FaTwitter, FaFacebookF, FaYoutube } from "react-icons/fa";

function SocialMediaIcons({ fonts, display }) {

  return (
    <>
      <ul className="list-unstyled text-start" style={display}>
        <li className="icon">
          <a
            href="https://www.facebook.com/paulinesbooks.centre/"
            target="_blank"
            rel="noreferrer"
            style={{ color: fonts ? fonts : "" }}
          >
            <FaFacebookF />
            Facebook
          </a>
        </li>
        <li className="icon">
          <a
            href="https://www.instagram.com/daughtersofstpaul_africa/?hl=en"
            target="_blank"
            rel="noreferrer"
            style={{ color: fonts ? fonts : "" }}
          >
            <FaInstagram />
            Instagram
          </a>
        </li>

        <li className="icon">
          <a
            href="https://mobile.twitter.com/africapaulines"
            target="_blank"
            rel="noreferrer"
            style={{ color: fonts ? fonts : "" }}
          >
            <FaTwitter />
            Twitter
          </a>
        </li>

        <li className="icon">
          <a
            href="https://www.youtube.com/channel/UCcTSXNL4ixtgjUluuIvxNXA/videos"
            target="_blank"
            rel="noreferrer"
            style={{ color: fonts ? fonts : "" }}
          >
            <FaYoutube />
            Youtube
          </a>
        </li>
      </ul>
    </>
  );
}

export default SocialMediaIcons;
